import router from '@/router/index';
import useStore from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useRoute, useRouter } from 'vue-router';
NProgress.configure({ showSpinner: false }); // 进度环显示/隐藏

// 白名单路由
const whiteList = [
  '/login',
  '/ban-page',
  '/h5Pay',
  '/client/main',
  '/client/purchase-account',
  '/mobile/login'
];

router.beforeEach(async (to, from, next) => {
  //去登录页面清除登录信息
  if (to.path.includes('/login')) {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('adminRoutes');
    next();
    return;
  }
  NProgress.start();
  const { user } = useStore();
  const hasToken = user?.userInfo?.token;
  const isAdmin = user?.userInfo?.user?.isAdmin;
  const permission = user?.userInfo?.permissions?.menus ?? [];
  const permissionKey = permission.map(item => item.path);

  function findExit(str) {
    let list = permissionKey.filter(it => {
      return it.includes(str);
    });
    if (list.length) {
      return true;
    } else {
      return false;
    }
  }

  //如果路径中有admin 则需要判断是否是管理员
  if (to.path.includes('admin')) {
    if (!isAdmin) {
      next(`/login?redirect=${to.path}`);
    } else if (!findExit(to.name as string)) {
      next(`/login?redirect=${to.path}`);
    }

    //管理员进后台要登录
    if (hasToken) {
      //判断
      next();
      NProgress.done();
    } else {
      // 未登录可以访问白名单页面(登录页面)
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next(`/login?redirect=${to.path}`);
        NProgress.done();
      }
    }
  }
  next();
  NProgress.done();
});

router.afterEach(() => {
  NProgress.done();
});
